module.exports = __webpack_public_path__ + "static/media/rabbit.1bc97d55.svg";